// saga
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  APPOINTMENT_LIST_REQUEST,
  APPOINTMENT_DATA_REQUEST,
  APPOINTMENT_CREATE_REQUEST,
  APPOINTMENT_UPDATE_REQUEST,
  APPOINTMENT_DELETE_REQUEST,
  APPOINTMENT_SEARCH_REQUEST,
  APPOINTMENT_TYPE_LIST_REQUEST,
  APPOINTMENT_TYPE_DATA_REQUEST,
  APPOINTMENT_TYPE_CREATE_REQUEST,
  APPOINTMENT_TYPE_UPDATE_REQUEST,
  APPOINTMENT_TYPE_DELETE_REQUEST,
  APPOINTMENT_STATUS_LIST_REQUEST,
  APPOINTMENT_STATUS_DATA_REQUEST,
  APPOINTMENT_STATUS_CREATE_REQUEST,
  APPOINTMENT_STATUS_UPDATE_REQUEST,
  APPOINTMENT_STATUS_DELETE_REQUEST,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST,
} from "./actionType";
import {
  appointmentListSuccess,
  appointmentListFail,
  appointmentDataSuccess,
  appointmentDataFail,
  appointmentCreateSuccess,
  appointmentCreateFail,
  appointmentUpdateSuccess,
  appointmentUpdateFail,
  appointmentDeleteSuccess,
  appointmentDeleteFail,
  appointmentSearchSuccess,
  appointmentSearchFail,
  appointmentTypeListSuccess,
  appointmentTypeListFail,
  appointmentTypeDataSuccess,
  appointmentTypeDataFail,
  appointmentTypeCreateSuccess,
  appointmentTypeCreateFail,
  appointmentTypeUpdateSuccess,
  appointmentTypeUpdateFail,
  appointmentTypeDeleteSuccess,
  appointmentTypeDeleteFail,
  appointmentStatusListSuccess,
  appointmentStatusListFail,
  appointmentStatusDataSuccess,
  appointmentStatusDataFail,
  appointmentStatusCreateSuccess,
  appointmentStatusCreateFail,
  appointmentStatusUpdateSuccess,
  appointmentStatusUpdateFail,
  appointmentStatusDeleteSuccess,
  appointmentStatusDeleteFail,
  appointmentSearchSpecificListSuccess,
  appointmentSearchSpecificListFail,
} from "./action";

import {
  appointmentListAPI,
  appointmentDataAPI,
  appointmentCreateAPI,
  appointmentUpdateAPI,
  appointmentDeleteAPI,
  appointmentSearchAPI,
  appointmentTypeListAPI,
  appointmentTypeDataAPI,
  appointmentTypeCreateAPI,
  appointmentTypeUpdateAPI,
  appointmentTypeDeleteAPI,
  appointmentStatusListAPI,
  appointmentStatusDataAPI,
  appointmentStatusCreateAPI,
  appointmentStatusUpdateAPI,
  appointmentStatusDeleteAPI,
  appointmentSearchSpecificListAPI,
} from "../../helpers/fakebackend_helper";

//Appointment List
function* appointmentListSaga({ payload }) {
  try {
    const response = yield call(appointmentListAPI, payload);
    yield put(appointmentListSuccess(response));
  } catch (error) {
    yield put(appointmentListFail(error));
  }
}
export function* watchAppointmentListSaga() {
  yield takeLatest(APPOINTMENT_LIST_REQUEST, appointmentListSaga);
}

//Appointment Data
function* appointmentDataSaga({ payload }) {
  try {
    const response = yield call(appointmentDataAPI, payload);
    yield put(appointmentDataSuccess(response));
  } catch (error) {
    yield put(appointmentDataFail(error));
  }
}
export function* watchAppointmentDataSaga() {
  yield takeLatest(APPOINTMENT_DATA_REQUEST, appointmentDataSaga);
}

//Appointment Create
function* appointmentCreateSaga({ payload }) {
  try {
    const response = yield call(appointmentCreateAPI, payload);
    yield put(appointmentCreateSuccess(response));
  } catch (error) {
    yield put(appointmentCreateFail(error));
  }
}
export function* watchAppointmentCreateSaga() {
  yield takeLatest(APPOINTMENT_CREATE_REQUEST, appointmentCreateSaga);
}

//Appointment Update
function* appointmentUpdateSaga({ payload }) {
  try {
    const response = yield call(appointmentUpdateAPI, payload);
    yield put(appointmentUpdateSuccess(response));
  } catch (error) {
    yield put(appointmentUpdateFail(error));
  }
}
export function* watchAppointmentUpdateSaga() {
  yield takeLatest(APPOINTMENT_UPDATE_REQUEST, appointmentUpdateSaga);
}

//Appointment Delete
function* appointmentDeleteSaga({ payload }) {
  try {
    const response = yield call(appointmentDeleteAPI, payload);
    yield put(appointmentDeleteSuccess(response));
  } catch (error) {
    yield put(appointmentDeleteFail(error));
  }
}
export function* watchAppointmentDeleteSaga() {
  yield takeLatest(APPOINTMENT_DELETE_REQUEST, appointmentDeleteSaga);
}

//Appointment Search
function* appointmentSearchSaga({ payload }) {
  try {
    const response = yield call(appointmentSearchAPI, payload);
    yield put(appointmentSearchSuccess(response));
  } catch (error) {
    yield put(appointmentSearchFail(error));
  }
}
export function* watchAppointmentSearchSaga() {
  yield takeLatest(APPOINTMENT_SEARCH_REQUEST, appointmentSearchSaga);
}

//Appointment Type List
function* appointmentTypeListSaga({ payload }) {
  try {
    const response = yield call(appointmentTypeListAPI, payload);
    yield put(appointmentTypeListSuccess(response));
  } catch (error) {
    yield put(appointmentTypeListFail(error));
  }
}
export function* watchAppointmentTypeListSaga() {
  yield takeLatest(APPOINTMENT_TYPE_LIST_REQUEST, appointmentTypeListSaga);
}

//Appointment Type Data
function* appointmentTypeDataSaga({ payload }) {
  try {
    const response = yield call(appointmentTypeDataAPI, payload);
    yield put(appointmentTypeDataSuccess(response));
  } catch (error) {
    yield put(appointmentTypeDataFail(error));
  }
}
export function* watchAppointmentTypeDataSaga() {
  yield takeLatest(APPOINTMENT_TYPE_DATA_REQUEST, appointmentTypeDataSaga);
}

//Appointment Type Create
function* appointmentTypeCreateSaga({ payload }) {
  try {
    const response = yield call(appointmentTypeCreateAPI, payload);
    yield put(appointmentTypeCreateSuccess(response));
  } catch (error) {
    yield put(appointmentTypeCreateFail(error));
  }
}
export function* watchAppointmentTypeCreateSaga() {
  yield takeLatest(APPOINTMENT_TYPE_CREATE_REQUEST, appointmentTypeCreateSaga);
}

//Appointment Type Update
function* appointmentTypeUpdateSaga({ payload }) {
  try {
    const response = yield call(appointmentTypeUpdateAPI, payload);
    yield put(appointmentTypeUpdateSuccess(response));
  } catch (error) {
    yield put(appointmentTypeUpdateFail(error));
  }
}
export function* watchAppointmentTypeUpdateSaga() {
  yield takeLatest(APPOINTMENT_TYPE_UPDATE_REQUEST, appointmentTypeUpdateSaga);
}

//Appointment Type Delete
function* appointmentTypeDeleteSaga({ payload }) {
  try {
    const response = yield call(appointmentTypeDeleteAPI, payload);
    yield put(appointmentTypeDeleteSuccess(response));
  } catch (error) {
    yield put(appointmentTypeDeleteFail(error));
  }
}
export function* watchAppointmentTypeDeleteSaga() {
  yield takeLatest(APPOINTMENT_TYPE_DELETE_REQUEST, appointmentTypeDeleteSaga);
}

//Appointment Status List
function* appointmentStatusListSaga() {
  try {
    const response = yield call(appointmentStatusListAPI);
    yield put(appointmentStatusListSuccess(response));
  } catch (error) {
    yield put(appointmentStatusListFail(error));
  }
}
export function* watchAppointmentStatusListSaga() {
  yield takeLatest(APPOINTMENT_STATUS_LIST_REQUEST, appointmentStatusListSaga);
}

//Appointment Status Data
function* appointmentStatusDataSaga({ payload }) {
  try {
    const response = yield call(appointmentStatusDataAPI, payload);
    yield put(appointmentStatusDataSuccess(response));
  } catch (error) {
    yield put(appointmentStatusDataFail(error));
  }
}
export function* watchAppointmentStatusDataSaga() {
  yield takeLatest(APPOINTMENT_STATUS_DATA_REQUEST, appointmentStatusDataSaga);
}

//Appointment Status Create
function* appointmentStatusCreateSaga({ payload }) {
  try {
    const response = yield call(appointmentStatusCreateAPI, payload);
    yield put(appointmentStatusCreateSuccess(response));
  } catch (error) {
    yield put(appointmentStatusCreateFail(error));
  }
}
export function* watchAppointmentStatusCreateSaga() {
  yield takeLatest(
    APPOINTMENT_STATUS_CREATE_REQUEST,
    appointmentStatusCreateSaga
  );
}

//Appointment Status Update
function* appointmentStatusUpdateSaga({ payload }) {
  try {
    const response = yield call(appointmentStatusUpdateAPI, payload);
    yield put(appointmentStatusUpdateSuccess(response));
  } catch (error) {
    yield put(appointmentStatusUpdateFail(error));
  }
}
export function* watchAppointmentStatusUpdateSaga() {
  yield takeLatest(
    APPOINTMENT_STATUS_UPDATE_REQUEST,
    appointmentStatusUpdateSaga
  );
}

//Appointment Status Delete
function* appointmentStatusDeleteSaga({ payload }) {
  try {
    const response = yield call(appointmentStatusDeleteAPI, payload);
    yield put(appointmentStatusDeleteSuccess(response));
  } catch (error) {
    yield put(appointmentStatusDeleteFail(error));
  }
}
export function* watchAppointmentStatusDeleteSaga() {
  yield takeLatest(
    APPOINTMENT_STATUS_DELETE_REQUEST,
    appointmentStatusDeleteSaga
  );
}

//Appointment Search Specific List
function* appointmentSearchSpecificListSaga({ payload }) {
  try {
    const response = yield call(appointmentSearchSpecificListAPI, payload);
    yield put(appointmentSearchSpecificListSuccess(response));
  } catch (error) {
    yield put(appointmentSearchSpecificListFail(error));
  }
}
export function* watchAppointmentSearchSpecificListSaga() {
  yield takeLatest(
    APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST,
    appointmentSearchSpecificListSaga
  );
}

export default function* Appointment() {
  yield all([
    watchAppointmentListSaga(),
    watchAppointmentDataSaga(),
    watchAppointmentCreateSaga(),
    watchAppointmentUpdateSaga(),
    watchAppointmentDeleteSaga(),
    watchAppointmentSearchSaga(),
    watchAppointmentTypeListSaga(),
    watchAppointmentTypeDataSaga(),
    watchAppointmentTypeCreateSaga(),
    watchAppointmentTypeUpdateSaga(),
    watchAppointmentTypeDeleteSaga(),
    watchAppointmentStatusListSaga(),
    watchAppointmentStatusDataSaga(),
    watchAppointmentStatusCreateSaga(),
    watchAppointmentStatusUpdateSaga(),
    watchAppointmentStatusDeleteSaga(),
    watchAppointmentSearchSpecificListSaga(),
  ]);
}
